@if (resumo; as r) {
  <div class="ced-finalizado-msg" [class.is-pendente]="r.isPendente">
    <mat-icon class="material-symbols-outlined ced-finalizado-icon">{{ r.isPendente ? 'pending_actions' : 'check_circle' }}</mat-icon>
    <div>
      <div class="ced-finalizado-title">{{ r.titulo }}</div>
      <div class="ced-finalizado-sub">{{ r.texto }}</div>
    </div>
  </div>
}

<!--
  Automações executadas: cada efeito pela origem congelada na entrada em Finalizado. Sem automação (origem nula), o
  efeito fica no bloco de cada NF ativa ou, sem NF, no do pedido, e o lançamento manual define a origem.
-->
<div class="section-title">
  <mat-icon>bolt</mat-icon>
  <span>Automações executadas</span>
  <span class="status-badge badge-cinza">{{ quantidadeAutomacoes }}</span>
</div>
<div class="ced-ped-hint">
  Lançados ao finalizar, pela origem configurada em cada automação (nota fiscal ou pedido).
  @if (tiposNota.length && notas.length) { O vínculo com a NF só é liberado depois de excluir o estoque e o financeiro dela. }
</div>

<!-- Enquanto o estado carrega, o shell cobre o corpo do card com o loader de página (carregandoChange). -->
@if ((tiposNota.length && notas.length) || tiposPedido.length) {
  @if (!carregando) {
    @if (tiposNota.length) {
      @for (n of notas; track n.idNFeEntrada) {
        @let efeitosNota = efeitosPorNota.get(n.idNFeEntrada) ?? [];
        <div class="ced-fin-nota">
          <div class="ced-fin-nota-head">
            <mat-icon class="material-symbols-outlined">receipt_long</mat-icon>
            <span class="ced-fin-nota-rotulo">{{ n.rotulo }}</span>
          </div>

          <div class="ced-fin-autos">
            @for (e of efeitosNota; track e.tipo) {
              <ng-container *ngTemplateOutlet="efeitoTpl; context: { $implicit: e, nota: n }"></ng-container>
            }
          </div>
        </div>
      }
    }

    @if (tiposPedido.length) {
      <div class="ced-fin-nota">
        <div class="ced-fin-nota-head">
          <mat-icon class="material-symbols-outlined">shopping_cart</mat-icon>
          <span class="ced-fin-nota-rotulo">{{ rotuloPedido }}</span>
        </div>

        <div class="ced-fin-autos">
          @for (e of efeitosPedido; track e.tipo) {
            <ng-container *ngTemplateOutlet="efeitoTpl; context: { $implicit: e, nota: null }"></ng-container>
          }
        </div>
      </div>
    }
  }
}

<ng-template #efeitoTpl let-e let-nota="nota">
  @let erro = erroEfeito(e, nota);
  <div class="ced-fin-auto">
    <span class="ced-fin-auto__ico"
      [class.is-pendente]="e.estado === estadoEfeito.NaoLancado"
      [class.is-inativo]="e.estado === estadoEfeito.Indisponivel">
      <mat-icon class="material-symbols-outlined">{{ e.tipo === tipoIntegracao.Estoque ? 'inventory_2' : 'account_balance_wallet' }}</mat-icon>
    </span>
    <div class="ced-fin-auto__body">
      <div class="ced-fin-auto__top">
        <span class="ced-fin-auto__name">{{ nomeEfeito(e.tipo) }}</span>
        @if (e.idsEstoqueMovimentacao?.length) {
          <button type="button" class="ced-mono ced-fin-auto__code ced-fin-auto__code--link" matTooltip="Ver movimentações"
            (click)="verMovimentacoes(e, nota)">{{ e.referencia }}</button>
        } @else if (e.referencia) {
          <span class="ced-mono ced-fin-auto__code">{{ e.referencia }}</span>
        }
      </div>
      <!-- Última tentativa falhou nesta sessão: o motivo substitui a descrição genérica e fica até lançar com sucesso. -->
      @if (erro) {
        <div class="ced-fin-auto__erro" role="alert">
          <mat-icon class="material-symbols-outlined">error</mat-icon>
          <span>Não foi possível lançar: {{ erro }}</span>
        </div>
      } @else {
        <div class="ced-fin-auto__sub">{{ descricaoEfeito(e) }}</div>
      }
    </div>
    <span class="status-badge badge-dot" [ngClass]="erro ? 'badge-vermelho' : classeEstado(e.estado)">{{ erro ? 'Falhou' : rotuloEstado(e.estado) }}</span>
    @if (e.estado === estadoEfeito.Lancado) {
      <span [matTooltip]="e.motivoBloqueioExcluir" [matTooltipDisabled]="!e.motivoBloqueioExcluir">
        <button mat-stroked-button type="button" class="btn-secondary btn-spinner"
          [class.btn-loading]="isExcluindo(nota?.idNFeEntrada ?? null, e.tipo)"
          [disabled]="isProcessando || !!e.motivoBloqueioExcluir"
          [attr.aria-label]="'Excluir ' + nomeEfeito(e.tipo).toLowerCase()"
          (click)="excluir(e, nota)">
          <mat-icon class="material-symbols-outlined">delete</mat-icon>
          Excluir {{ nomeEfeito(e.tipo).toLowerCase() }}
          @if (isExcluindo(nota?.idNFeEntrada ?? null, e.tipo)) { <mat-spinner diameter="20"></mat-spinner> }
        </button>
      </span>
    } @else {
      <!-- Não lançado ou com falha: lança só este efeito; sem confirmação fica bloqueado com o motivo. -->
      @let motivoLancar = motivoBloqueioLancar(e);
      <span [matTooltip]="motivoLancar" [matTooltipDisabled]="!motivoLancar">
        <button mat-stroked-button type="button" class="btn-secondary btn-spinner"
          [class.btn-loading]="isLancando(nota?.idNFeEntrada ?? null, e.tipo)"
          [disabled]="!!motivoLancar"
          [attr.aria-label]="'Lançar ' + nomeEfeito(e.tipo).toLowerCase()"
          (click)="lancarEfeito(e, nota)">
          <mat-icon class="material-symbols-outlined">play_arrow</mat-icon>
          Lançar {{ nomeEfeito(e.tipo).toLowerCase() }}
          @if (isLancando(nota?.idNFeEntrada ?? null, e.tipo)) { <mat-spinner diameter="20"></mat-spinner> }
        </button>
      </span>
    }
  </div>
</ng-template>

<!-- Pedido marcado sem nota fiscal no card: motivo informado (somente leitura) -->
@if (isSemNotaFiscal) {
  <div class="ced-field">
    <mat-form-field appearance="outline" class="ced-form-field">
      <mat-label>Motivo da compra sem nota fiscal</mat-label>
      <input matInput [value]="motivoSemNotaFiscal || '—'" readonly>
    </mat-form-field>
  </div>
}

<!-- Dados de finalização: gravados na entrada em Finalizado -->
<div class="ced-field-grid">
  <mat-form-field appearance="outline" class="ced-form-field">
    <mat-label>Data de finalização</mat-label>
    <input matInput [value]="dataFinalizacao" readonly>
  </mat-form-field>
  <mat-form-field appearance="outline" class="ced-form-field">
    <mat-label>Finalizado por</mat-label>
    <input matInput [value]="finalizadoPor" readonly>
  </mat-form-field>
</div>

<!-- Observação de encerramento: única edição em Finalizado -->
<div class="ced-field">
  <mat-form-field appearance="outline" class="ced-form-field">
    <mat-label>Observação de encerramento</mat-label>
    <textarea matInput rows="3" [ngModel]="observacao" (ngModelChange)="observacao = $event; observacaoChange.emit($event)"
      placeholder="Notas de encerramento. Visíveis no histórico do card."></textarea>
  </mat-form-field>
</div>
